export default __webpack_public_path__ + "d878b0a6a1144760244ff0665888404c.woff2";